// extracted by mini-css-extract-plugin
export default {"model":"Model_model__ZqLxq","model__view":"Model_model__view__8btIs"};